module.exports = __webpack_public_path__ + "img/cellcard-en.e4512a34.png";